import {FORWARD, REVERSE, FORWARD_REVERSE, BROWNIAN} from 'constants/playhead-directions.js';
import {PLAYHEAD_EFFECT} from 'effects/live/constants.js';

export default superclass => class extends superclass  {
    getPatternStep(currentStep, isSequencer=false) {

        if (this.isMetronome) {
            let startStep = this.pattern.startStep === undefined ?
                0 :
            this.pattern.startStep;
            let len = this.pattern.length();
            return this.subSequence.isTrack ?
                currentStep - startStep:
                currentStep % len;
        }

        if (!isSequencer) {
            // it's the UI so just use last pattern step
            if (!this.playheadEffect && this.pattern && (this.speedFactor === 1)) {
                return currentStep % this.pattern.length();
            }
            return this.lastPatternStep || 0;
        }

        let startStep = this.pattern.startStep === undefined ?
            0 :
            this.pattern.startStep;
        let len = this.pattern.length();
        
        let direction = this.playheadDirection;
        if (direction === BROWNIAN) {
            return this.getBrownian(currentStep, isSequencer);
        }

        let _currentStep = currentStep * this.speedFactor +  Math.floor(this.offset);
        let originalStep = currentStep;

        currentStep = _currentStep;

        var patternStep = this.subSequence.isTrack ?
            currentStep - startStep:
            currentStep % len;

        if (isSequencer & this.speedFactor < 1) {
            if (patternStep === this.lastPatternStep) {
                return undefined;
            }
        }
        if (direction === FORWARD_REVERSE) {
            // figure out if current step is in a the forward or back part
            if (Math.floor(currentStep  / len) % 2 === 0) {
                direction = FORWARD;
            } else {
                direction = REVERSE;
            }
        }


        if (direction === REVERSE) {
            if (this.playheadDirection === FORWARD_REVERSE) {
                patternStep = len - patternStep;
                if (patternStep === len) {
                    patternStep = len - 2;
                }
            } else {
                patternStep = len - patternStep - 2;
            }
        } 
        this.lastPatternDirection = direction;
        this.lastPatternStep = patternStep;
        return patternStep;
    }

    isPlayheadReversed() {
        return this.lastPatternDirection === REVERSE;
    }

    get playheadEffect() {
        if (this.cachedPlayhead) {
            return this.cachedPlayhead;
        }
        this.cachedPlayhead = this.liveEffects.effects.find(
            fx => fx.effect === PLAYHEAD_EFFECT);
        return this.cachedPlayhead;
    }

    get playheadDirection() {
        // first check if theres a playhead live effect
        let playheadEffect = this.playheadEffect;

        if (playheadEffect) {
            if (this.subSequencePlayhead.direction !== FORWARD) {
                // overrides
                return this.subSequencePlayhead.direction;
            }
            return playheadEffect.direction;
        }
        return FORWARD;
    }

    get subSequencePlayhead() {
        return this.subSequence.playhead;
    }

    get speedFactor() {
        let playheadEffect = this.playheadEffect;

        if (playheadEffect) {
            return this.subSequence.playhead.speedFactor * playheadEffect.speedFactor;
        }
        return this.subSequence.playhead.speedFactor;
    }

    get offset() {
        let playheadEffect = this.playheadEffect;

        if (playheadEffect) {
            return playheadEffect.offset;
        }
        return 0;
    }

    get walk() {
        let playheadEffect = this.playheadEffect;

        if (playheadEffect) {
            return playheadEffect.walk;
        }
        return 2;
    }

    getBrownian(currentStep, isSequencer=true) {
        // check last brownian step returned

        // if there is none then just return currentStep
        if (this.lastPatternStep === undefined && isSequencer) {
            this.lastPatternStep = currentStep;
            return currentStep;
        }

        currentStep = this.lastPatternStep;

        if ((currentStep + 1 ) % this.walk === 0) {
            // it's time to make a decision and flip the coin
            let rand = Math.random();
            if (rand < 0.5) {
                // go to next section of the beat 50% of the time
               currentStep += 1;
            } else if (rand < 0.75) {
                // go backwards 25% o the time
                currentStep -= 2 * this.walk - 1;
            } else {
                currentStep -= this.walk - 1;
            }
            if (currentStep < 0) {
                currentStep = this.pattern.length() - this.walk;
            } else {
                currentStep = currentStep % this.pattern.length();
            }
        } else {
            // otherwise we proceed to walk forward
            currentStep++;
        }
        if (isSequencer) {
            this.lastPatternStep = currentStep;
        }
        return currentStep;
    }

    /**
     * Walk = 2
     * every 2 steps you make the decision as to whether to go forward or bacwards
     */
}
